export default "__VITE_ASSET__DCR14Sjl__"